import { render } from "./TextAccess.vue?vue&type=template&id=5a924a03&scoped=true"
import script from "./TextAccess.vue?vue&type=script&lang=js"
export * from "./TextAccess.vue?vue&type=script&lang=js"

import "./TextAccess.vue?vue&type=style&index=0&id=5a924a03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a924a03"]])

export default __exports__